'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _UnsafeUrl = require('../utils/UnsafeUrl');

var _validHref = require('../utils/propTypes/validHref');

var _validHref2 = _interopRequireDefault(_validHref);

var _ThrowError = require('../utils/ThrowError');

var _Functions = require('../core/Functions');

var _Styles = require('../utils/Styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SHAPE_CLASSES = {
  default: '',
  circle: 'img-circle private-image--circle',
  rounded: 'img-rounded private-image--rounded',
  thumbnail: 'img-thumbnail private-image--thumbnail'
};

var OBJECT_FIT_CLASSES = {
  fill: '',
  contain: 'private-image--object-fit-contain'
};

exports.default = _react2.default.createClass({
  displayName: 'UIImage',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    alt: _react.PropTypes.string.isRequired,
    bordered: _react.PropTypes.bool.isRequired,
    className: _react.PropTypes.string,
    height: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    onError: _react.PropTypes.func,
    onLoad: _react.PropTypes.func,
    objectFit: _react.PropTypes.oneOf(Object.keys(OBJECT_FIT_CLASSES)).isRequired,
    responsive: _react.PropTypes.bool.isRequired,
    shape: _react.PropTypes.oneOf(Object.keys(SHAPE_CLASSES)).isRequired,
    src: _validHref2.default.isRequired,
    style: _react.PropTypes.object,
    width: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      alt: '',
      bordered: false,
      objectFit: 'fill',
      responsive: true,
      shape: 'default'
    };
  },
  getInitialState: function getInitialState() {
    return {
      computedStyle: this.props.style,
      loadFailed: false,
      overrides: {}
    };
  },
  componentDidMount: function componentDidMount() {
    this.polyfillObjectFit();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var overrides = this.state.overrides;

    this.setState({
      computedStyle: _extends({}, nextProps.style, overrides)
    });
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    // ⚠️ This condition prevents infinite loops! ⚠️
    if (prevState.overrides === this.state.overrides) {
      this.polyfillObjectFit();
    }
  },
  handleImageError: function handleImageError(evt) {
    var onError = this.props.onError;

    this.setState({
      loadFailed: true
    });
    (0, _Functions.callIfPossible)(onError, evt);
  },
  handleImageLoad: function handleImageLoad(evt) {
    var onLoad = this.props.onLoad;

    this.setState({
      loadFailed: false
    });
    (0, _Functions.callIfPossible)(onLoad, evt);
  },
  polyfillObjectFit: function polyfillObjectFit() {
    var _props = this.props,
        objectFit = _props.objectFit,
        style = _props.style;

    if (!('objectFit' in document.documentElement.style) && objectFit === 'contain' && document.body && this._img) {
      var _img = this._img,
          naturalWidth = _img.naturalWidth,
          naturalHeight = _img.naturalHeight;

      if (!naturalWidth || !naturalHeight) return;
      var imgAspectRatio = naturalWidth / naturalHeight;

      // Reset existing overrides on <img>
      var imgStyles = this._img.style;
      var originalImgWidth = imgStyles.width;
      var originalImgHeight = imgStyles.height;
      if (this.state.overrides.width) {
        imgStyles.width = style ? (0, _Styles.toPx)(style.width) : '';
      } else if (this.state.overrides.height) {
        imgStyles.height = style ? (0, _Styles.toPx)(style.height) : '';
      }

      var _img$getBoundingClien = this._img.getBoundingClientRect(),
          renderedWidth = _img$getBoundingClien.width,
          renderedHeight = _img$getBoundingClien.height;

      var fittedHeight = renderedWidth / imgAspectRatio;
      var fittedWidth = renderedHeight * imgAspectRatio;
      var overrides = {};
      if (renderedHeight > fittedHeight) {
        overrides = { height: fittedHeight };
      } else if (renderedWidth > fittedWidth) {
        overrides = { width: fittedWidth };
      }
      this.updateOverrides(overrides);
      imgStyles.width = originalImgWidth;
      imgStyles.height = originalImgHeight;
    }
  },
  updateOverrides: function updateOverrides(overrides) {
    var style = this.props.style;

    this.setState({
      computedStyle: _extends({}, style, overrides),
      overrides: overrides
    });
  },
  getClassName: function getClassName(_ref) {
    var bordered = _ref.bordered,
        className = _ref.className,
        objectFit = _ref.objectFit,
        responsive = _ref.responsive,
        shape = _ref.shape;

    return (0, _classNames2.default)('private-image', SHAPE_CLASSES[shape], OBJECT_FIT_CLASSES[objectFit], className, {
      'img-responsive private-image--responsive': responsive,
      'image-load-failed': this.state.loadFailed,
      'private-image--bordered': bordered
    });
  },
  render: function render() {
    var _this = this;

    var _props2 = this.props,
        alt = _props2.alt,
        bordered = _props2.bordered,
        className = _props2.className,
        objectFit = _props2.objectFit,
        responsive = _props2.responsive,
        shape = _props2.shape,
        src = _props2.src,
        __style = _props2.style,
        rest = _objectWithoutProperties(_props2, ['alt', 'bordered', 'className', 'objectFit', 'responsive', 'shape', 'src', 'style']);

    if ((0, _UnsafeUrl.isUnsafeUrl)(src)) {
      (0, _ThrowError.throwErrorAsync)(new Error('UIImage: Detected XSS attempt! src="' + src + '"'));
    }

    var computedStyle = this.state.computedStyle;


    return _react2.default.createElement('img', _extends({}, rest, {
      alt: alt,
      className: this.getClassName({
        bordered: bordered,
        className: className,
        objectFit: objectFit,
        responsive: responsive,
        shape: shape
      }),
      key: src,
      onError: this.handleImageError,
      onLoad: this.handleImageLoad,
      ref: function ref(_ref2) {
        _this._img = _ref2;
      },
      src: (0, _UnsafeUrl.isUnsafeUrl)(src) ? null : src,
      style: computedStyle
    }));
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/image/UIImage.js
// module id = 107
// module chunks = 2 3